import { render, staticRenderFns } from "./PlatformBxHc.vue?vue&type=template&id=7a5cef8f&scoped=true&"
import script from "./PlatformBxHc.vue?vue&type=script&lang=js&"
export * from "./PlatformBxHc.vue?vue&type=script&lang=js&"
import style0 from "./PlatformBxHc.vue?vue&type=style&index=0&id=7a5cef8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5cef8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSwitch,VTab,VTabItem,VTabs,VTabsSlider,VTextarea,VTreeview})
